import { ref } from 'vue'
import { request } from '../request'
import service from '../request'

/** 律师圈子-帖子列表（分页+分类筛选+关键词搜索） */
export function listCirclePost(data) {
  return request('circle/listPost', data)
}

/** 律师圈子-发布动态 */
export function addCirclePost(data) {
  return request('circle/addPost', data)
}

/** 律师圈子-删除动态（逻辑删：作者本人或超管） */
export function delCirclePost(data) {
  return request('circle/delPost', data)
}

/** 律师圈子-超管隐藏/恢复动态（is_hidden: 1隐藏 0恢复） */
export function hideCirclePost(data) {
  return request('circle/hidePost', data)
}

/** 律师圈子-帖子点赞/取消点赞 */
export function toggleLikePost(data) {
  return request('circle/toggleLikePost', { ...data, _hideLoading: true })
}

/** 律师圈子-评论列表 */
export function listCircleComment(data) {
  return request('circle/listComment', { ...data, _hideLoading: true })
}

/** 律师圈子-发表评论/回复 */
export function addCircleComment(data) {
  return request('circle/addComment', { ...data, _hideLoading: true })
}

/** 律师圈子-评论点赞/取消点赞 */
export function toggleLikeComment(data) {
  return request('circle/toggleLikeComment', { ...data, _hideLoading: true })
}

/** 律师圈子-右侧栏（所内公告/热门话题/活跃律师榜） */
export function getCircleSidebar(data) {
  return request('circle/getSidebar', { ...data, _hideLoading: true })
}

/** 律师圈子-顶部滚动播报：近 10 分钟新内容 */
export function listRecentCirclePost(data) {
  return request('circle/listRecent', { ...data, _hideLoading: true })
}

/** 律师专属空间-用户信息+积分+等级 */
export function getCircleSpace(data) {
  return request('circle/getSpace', { ...data, _hideLoading: true })
}

/** 律师专属空间-保存昵称（仅本人，圈子内展示优先于真实姓名） */
export function saveCircleNickname(data) {
  return request('circle/saveNickname', data)
}

/** 律师专属空间-某用户的动态列表 */
export function listUserCirclePost(data) {
  return request('circle/listUserPost', data)
}

/** 律师专属空间-积分明细 */
export function listCircleScoreLog(data) {
  return request('circle/listScoreLog', { ...data, _hideLoading: true })
}

// ============================================================
// 律师圈子菜单角标：近 30 分钟内新内容数
// 全局共享状态，MainLayout 展示、LawyerCircle 进入后清零
// ============================================================
const CIRCLE_LAST_VIEWED_KEY = 'circleLastViewed'
export const circleNewCount = ref(0)
let _circleTimer = null

function _circleNewCountApi() {
  const since = localStorage.getItem(CIRCLE_LAST_VIEWED_KEY) || ''
  return request('circle/newCount', { since, _hideLoading: true, _hideError: true }).catch(() => ({ count: 0 }))
}

export async function refreshCircleNewCount() {
  try {
    const data = await _circleNewCountApi()
    circleNewCount.value = Number(data?.count) || 0
  } catch {
    // 静默失败
  }
}

/** 启动角标轮询（60s 刷新一次） */
export function startCircleCountPolling() {
  refreshCircleNewCount()
  if (_circleTimer) return
  _circleTimer = setInterval(refreshCircleNewCount, 60 * 1000)
}

/** 用户进入圈子页：清除角标并记录最后查看时间 */
export function clearCircleNewCount() {
  circleNewCount.value = 0
  localStorage.setItem(CIRCLE_LAST_VIEWED_KEY, String(Date.now()))
}

/**
 * 律师圈子-本地文件上传（multipart/form-data）
 * 后端保存到 uploads/{日期}/{文件}，返回 full_path 可直接访问
 * @param {FormData} formData 含 file 字段
 * @param {Function} onUploadProgress 上传进度回调
 */
export function uploadCircleFile(formData, onUploadProgress) {
  const base = import.meta.env.VITE_API_BASE_URL || '/api/{method}'
  return service.post(base.replace('{method}', 'upload/uploadLocal'), formData, {
    timeout: 120000,
    onUploadProgress,
  })
}
